<style lang="less" scoped>
  .warranty-query {
    position: relative;
    height: 100%;
    overflow: hidden;
    background: @DefaultColor;
    background: linear-gradient(180deg, @DefaultColor, @DefaultSubColor);
    .home-bg {
      position: absolute;
      top: 34rpx;
      left: 0;
      width: 100%;
      z-index: 0;
    }
    .home-content {
      position: absolute;
      bottom: 16rpx;
      left: 30rpx;
      right: 30rpx;
      z-index: 1;
    }
    .home-content-form {
      padding: 60rpx 70rpx;
      background: #fff;
      border-radius: 10rpx;
    }
    .content-title {
      display: block;
      width: 100%;
      padding: 0 75rpx;
      margin-bottom: 46rpx;
      font-size: 1.2rem;
      box-sizing: border-box;
    }
    .content-title-sub {
      margin-bottom: 54rpx;
      color: #3473f6;
      text-align: center;
    }
    .query-code-input {
      width: 100%;
      height: 80rpx;
      margin-bottom: 54rpx;
      border: 0;
      outline: 0;
      color: #333;
      padding: 16rpx 30rpx;
      background: #fff;
      box-sizing: border-box;
      border-radius: 40rpx;
      text-align: center;
      box-shadow: inset 0 0 1px 0 #999;
      transition: box-shadow 0.2s ease;
      &:focus {
        box-shadow: inset 0 0 1px 1px #3473f6;
      }
    }
    .query-button {
      width: 100%;
      height: 80rpx;
      font-weight: 600;
      color: #fff;
      background: @DefaultColor;
      border-radius: 40rpx;
      border: 0;
      outline: 0;
      transition: background-color 0.2s ease;
      &:active {
        background: #ea6b55;
      }
      &[disabled] {
        background: #e2e2e2;
      }
    }
  }
</style>

<template>
  <div class="warranty-query">
    <img class="home-bg"
         src="~@/assets/bg_warranty_home.png">
    <div class="home-content">
      <div class="home-content-form">
        <img class="content-title"
             src="~@/assets/icon_warranty_home_title.png">

        <div class="content-title-sub">输入手机号/订单号,自动查询订单</div>

        <input class="query-code-input"
               type="text"
               placeholder="请输入订单号/手机号/车牌号"
               v-model="warrantyCode">

        <button :disabled="!warrantyCode || !tenantId"
                @click="jumpToList"
                class="query-button">立即查询</button>
      </div>
      <div class="safe-area-bottom"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WarrantyHome',
    data () {
      return {
        tenantId: '',
        warrantyCode: ''
      }
    },
    methods: {
      jumpToList () {
        if (!this.tenantId || !this.warrantyCode) {
          this.$toast('初始化失败，tenant id 获取失败')
          return false
        }
        this.$router.push({
          path: '/order-list',
          query: {
            usr: this.tenantId,
            key: this.warrantyCode
          }
        })
      }
    },
    mounted () {
      this.tenantId = this.$route.query.usr || ''
      if (!this.tenantId) {
        this.$toast('初始化失败，tenant id 获取失败')
      }
    }
  }
</script>
